var exports = {
  "kL": "CollapsedCategoryVoiceParticipants.module__container___N1R1dT",
  "Kk": "CollapsedCategoryVoiceParticipants.module__icon___N1R1dT",
  "nU": "CollapsedCategoryVoiceParticipants.module__channelContainer___N1R1dT",
};

module.exports = exports;
